import { RequestOrganizationMessages } from './../../types/types';
import { MessagesModule } from '../../types/types';
import { default as pluralizationsAndDateLocaleData } from 'react-intl/locale-data/en.js';
import { messages as defaultMessages } from './default/en-US';
import { messages as firstResponder } from './firstResponder/en-US';
import { messages as military } from './military/en-US';
import { messages as senior } from './senior/en-US';
import { messages as student } from './student/en-US';
import { messages as teacher } from './teacher/en-US';
import { messages as medical } from './medical/en-US';
import { messages as employment } from './employment/en-US';
import { messages as requestOrg } from './requestOrganization/en-US';

export const messages: MessagesModule = {
    defaultMessages,
    pluralizationsAndDateLocaleData,
    segmentMessages: {
        firstResponder,
        military,
        senior,
        student,
        teacher,
        medical,
        employment,
    },
};

export const requestOrganizationMessages: RequestOrganizationMessages = {
    ...defaultMessages,
    ...requestOrg,
};
